<template>
<file-pond
    ref="pond"
    label-idle="Drag & Drop your image or <span class='filepond--label-action'>Browse</span>"
    :max-files="1"
    max-file-size="3MB"
    accepted-file-types="image/*"
    file-validate-type-label-expected-types="Expects an image"
    :files="files"
    :server="serverConfig"
    @updatefiles="onFileUpdate"
/>
</template>

<script>
import { FileStatus } from 'filepond'
import { mapGetters } from 'vuex'
import vueFilePond from 'vue-filepond'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js'
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'

import * as M from '@/store/mutations'
import * as C from '@shared/constants'
import api from '@/api'

const mutation = M.SET_HEADER_IMAGE_LOADING_STATE

const FilePond = vueFilePond(
    FilePondPluginFileValidateType,
    FilePondPluginImagePreview,
    FilePondPluginFileValidateSize)

export default {
    name: 'ConfigHeaderImage',
    props: {
        headerImgUrl: String,
    },
    data: vm => ({
        files: [],
    }),
    created () {
        this.serverConfig = {
            // https://pqina.nl/filepond/docs/api/server/#process-1
            process: (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
                const controller = new AbortController()

                const formData = new FormData()
                formData.append(fieldName, file, file.name)

                api.post(
                    `/channels/${this.channelId}/image/upload`,
                    formData,
                    {
                        signal: controller.signal,
                        onUploadProgress: event => {
                            progress(true, event.loaded, event.total)
                        }
                    }
                ).then(res => {
                    load(res.data.imgURL)
                    this.$store.commit(mutation, { state: C.STATE_SUCCESS })
                    this.updateHeaderImgUrl(res.data.imgURL)
                }).catch(() => {
                    this.$store.commit(mutation, { state: C.STATE_ERROR })
                })

                return {
                    abort: () => {
                        controller.abort()
                        abort()
                    }
                }
            },
            fetch: null,
            revert: null,
        }
    },
    computed: {
        ...mapGetters(['channelId']),
    },
    methods: {
        onFileUpdate (files) {
            this.$store.commit(mutation, { state: C.STATE_DEFAULT })

            let url = ''
            const file = files[0]
            if (file && file?.status !== FileStatus.LOAD_ERROR) {
                url = URL.createObjectURL(file.file)
                this.$store.commit(mutation, { state: C.STATE_LOADING })
            }
            this.updateHeaderImgUrl(url)
        },
        updateHeaderImgUrl (url) {
            this.$emit('update:headerImgUrl', url)
        }
    },
    components: {
        FilePond,
    },
}
</script>

<style lang="scss" scoped>

</style>
